import React, { useState } from 'react';
import { Box, Tabs, Tab, Typography, Paper } from '@mui/material';
import MyEquipment from './MyEquipment';
import MyEquipmentRequests from './MyEquipmentRequests';
import EquipmentRequestForm from './EquipmentRequestForm';

function TabPanel({ children, value, index, ...other }) {
  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
}

export default function EquipmentPage() {
  const [tab, setTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Equipment
      </Typography>

      <Paper sx={{ mb: 2 }}>
        <Tabs value={tab} onChange={handleTabChange}>
          <Tab label="My Equipment" />
          <Tab label="My Requests" />
          <Tab label="New Request" />
        </Tabs>
      </Paper>

      <TabPanel value={tab} index={0}>
        <MyEquipment />
      </TabPanel>

      <TabPanel value={tab} index={1}>
        <MyEquipmentRequests />
      </TabPanel>

      <TabPanel value={tab} index={2}>
        <EquipmentRequestForm onSuccess={() => setTab(1)} />
      </TabPanel>
    </Box>
  );
}

